<div class="container-fluid-modal">

    <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

    <div class="add" *ngIf="!editData">
            <div class="ModalHeader">
                <h4 mat-dialog-title>Add Antenna</h4>
                <div class="headerButton">
                    <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                    </button>
                    <button type="button" class="btn btn-warning"  matDialogClose (click)="close()"><i class="fa fa-times" aria-hidden="true" ></i> Cancel
                    </button>
                </div>
            </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                    <div class="form-group col-lg-12">
                        <div class="form-group col-lg-12">
                            <label for="Name" class="labelRequired">Name </label>
                            <input type="text" class="form-control" placeholder="Name" name="name" #name="ngModel" [(ngModel)]="user.name" required [ngClass]= "{'has-danger': cat?.submitted  && name?.invalid }">
                            <div *ngIf="cat?.submitted  && name?.invalid ">
                                <div [hidden]="!name.errors.required" class="formError"> * Antenna Name is required </div>
                            </div>
                        </div>

                         <div class="form-group col-lg-12">
                            <label for="Number" class="labelRequired">Number </label>
                            <input type="text" class="form-control" placeholder="Number" name="number" #number="ngModel" ngModel required [ngClass]="{'has-danger':cat?.submitted && number?.invalid }">
                            <div *ngIf="cat?.submitted && number?.invalid">
                                <div [hidden]="!number.errors.required" class="formError"> * Number is required </div>
                            </div>
                        </div>

                    </div>
            </div>

        </div>

    </mat-dialog-content>
</div>

    <div class="edit" *ngIf= "editData">
                <div class="ModalHeader">
                    <h4 mat-dialog-title>Edit Antenna</h4>
                    <div class="headerButton">
                        <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                        </button>
                        <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
                                class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>

                <mat-dialog-content>
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group col-lg-12">
                                <div class="form-group col-lg-12">
                                    <label for="Name" class="labelRequired">Name </label>
                                    <input type="text" class="form-control" placeholder="Name" name="name" [(ngModel)]="editData.name" required #name="ngModel" [ngClass]="{'has-danger':name?.invalid && name?.touched }">
                                    <div *ngIf="name?.errors && (name?.dirty || name?.touched)">
                                            <div [hidden]="!name.errors.required" class="formError"> *Antenna Name is required </div>
                                    </div>
                                </div>

                                <div class="form-group col-lg-12">
                                    <label for="Number" class="labelRequired">Number </label>
                                    <input type="text" class="form-control" placeholder="Number" name="number" [(ngModel)]="editData.number" required #number="ngModel" [ngClass]="{'has-danger':number?.invalid && number?.touched }">
                                    <div *ngIf="number?.errors && (number?.dirty || number?.touched)">
                                            <div [hidden]="!number.errors.required" class="formError"> *Number is required </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </mat-dialog-content>
            </div>

    </form>
</div>
